import { getRoundedRate } from '@common/utils';
import { orderStore } from '@store/orders';
import { LineItemViewModel } from '@typeDefinitions/lineItemTypes';
import { sum } from 'lodash';

const carrierPay = (item: LineItemViewModel[]) => {
  return item
    .filter((lineItem) => lineItem.operationType !== 'Delete')
    .reduce(
      (total, item) =>
        total + getRoundedRate(Number(item.rate), Number(item.quantity)),
      0,
    );
};

const vendorPay = (index: number) => {
  if (orderStore.order.vendors) {
    return (orderStore.order.vendors[index].lineItems || []).reduce(
      (total, item) => total + getRoundedRate(item.rate, item.quantity),
      0,
    );
  }
};

export const totalOrderExpenses = () => {
  return (
    sum(
      orderStore.order.loads
        .filter((i) => i.status !== 'Void')
        .map((item) => {
          return carrierPay(item.lineItems ?? []);
        }),
    ) +
    sum(
      (orderStore.order.vendors || []).map((vendor, i: number) => {
        return vendor.status === 'Void' ? 0 : vendorPay(i);
      }),
    )
  );
};

export const customerPay = () => {
  return orderStore.order.lineItems.length > 0
    ? orderStore.order.lineItems.reduce(
        (acc, item) =>
          acc + getRoundedRate(Number(item.rate), Number(item.quantity)),
        0,
      )
    : 0;
};
